module.exports = __webpack_public_path__ + "img/23.68a922b0.png";